import { OnInit, OnDestroy } from '@angular/core';
import { IdentifyingClient } from '../../shared/api/identifying-api.generated';
import { AdministratorClient } from '../../shared/api/administrator-api.generated';
import { Subscription, combineLatest, BehaviorSubject, of as _observableOf } from 'rxjs';
import { filter, switchMap, map, distinctUntilChanged, catchError, debounceTime } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UserSettingsService } from '../../core/services/user-settings.service';
import { PortalService } from '../../core/services/portal.service';
import { environment } from '../../../environments/environment';
import { BatchActionService, BatchSelectionType } from '../../core/services/batch-action.service';
import { DeleteModalComponent, DeleteModalProps } from '../../shared/components/delete-modal/delete-modal.component';
import { JobScansFilterService } from '../jobscans-filter.service';
var JobScansComponent = /** @class */ (function () {
    function JobScansComponent(identifyingClient, administratorClient, userSettingsService, portalService, batchActionService, modalService, translate, jobScansFilterService) {
        this.identifyingClient = identifyingClient;
        this.administratorClient = administratorClient;
        this.userSettingsService = userSettingsService;
        this.portalService = portalService;
        this.batchActionService = batchActionService;
        this.modalService = modalService;
        this.translate = translate;
        this.jobScansFilterService = jobScansFilterService;
        this.page = 1;
        this.pageSize = environment.api.pageSize;
        this.jobScans = [];
        this.subscriptions = [];
        this.fetch$ = new BehaviorSubject(false);
        this.sortOn = '-createdOn';
    }
    JobScansComponent.prototype.ngOnInit = function () {
        var _this = this;
        var jobScansSub = combineLatest(this.fetch$, this.jobScansFilterService.filter$, this.userSettingsService.currentAccount$, this.portalService.expectations$, this.portalService.domains$)
            .pipe(filter(function (_a) {
            var fetch = _a[0], jobScansFilter = _a[1], account = _a[2], expectations = _a[3], domains = _a[4];
            return fetch && !!account && !!expectations && !!domains;
        }), debounceTime(500), switchMap(function (_a) {
            var fetch = _a[0], jobScansFilter = _a[1], account = _a[2], expectation = _a[3], domains = _a[4];
            var offset = (_this.page - 1) * _this.pageSize;
            _this.loading = true;
            return _this.administratorClient.getJobScansForAccountAndClientType(account.id, 4, undefined, /* externalRef */ undefined /* shouldHaveExpectations */, true /* includeExpectations */, jobScansFilter.teamRoleIds, jobScansFilter.workValueIds, offset, _this.pageSize, _this.sortOn, jobScansFilter.search, jobScansFilter.domainIds).pipe(map(function (jobScans) {
                jobScans.forEach(function (jp) {
                    jp.expectations = _this.mapExpectations(jp, expectation);
                    jp.domains = _this.mapDomains(jp, domains);
                });
                return jobScans;
            }), catchError(function (err) { return _observableOf([]); }));
        })).subscribe(function (jobScans) {
            _this.totalCount = jobScans.length;
            _this.loading = false;
            Array.prototype.push.apply(_this.jobScans, jobScans);
            _this.fetch$.next(false);
        });
        var accountSub = this.userSettingsService
            .currentAccount$
            .pipe(filter(function (p) { return !!p; }), distinctUntilChanged())
            .subscribe(function (account) { return _this.reset(); });
        var batchDeleteSub = this.batchActionService
            .delete$
            .pipe(filter(function (res) { return res.selectionType === BatchSelectionType.Jobs; }))
            .subscribe(function (res) { return _this.showBatchDeleteConfirmationModal(res.selection); });
        var batchActionBarVisibleSub = this.batchActionService
            .actionBarVisible$
            .subscribe(function (actionBarVisible) { return _this.actionBarVisible = actionBarVisible; });
        var filterSub = this.jobScansFilterService.filter$
            .subscribe(function (jobScansFilter) {
            _this.filter = jobScansFilter;
            _this.reset();
        });
        var totalCountSub = combineLatest(this.userSettingsService.currentAccount$, this.jobScansFilterService.filter$)
            .pipe(filter(function (_a) {
            var account = _a[0], jobScansFilter = _a[1];
            return !!account;
        }), switchMap(function (_a) {
            var account = _a[0], jobScansFilter = _a[1];
            return _observableOf(_this.totalCount);
        })).subscribe(function (totalCount) { return _this.totalCount = totalCount; });
        this.subscriptions.push(jobScansSub);
        this.subscriptions.push(accountSub);
        this.subscriptions.push(batchDeleteSub);
        this.subscriptions.push(batchActionBarVisibleSub);
        this.subscriptions.push(filterSub);
        this.subscriptions.push(totalCountSub);
    };
    JobScansComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    JobScansComponent.prototype.getJobScans = function () {
        this.page++;
        this.fetch$.next(true);
    };
    JobScansComponent.prototype.sort = function (sortOn) {
        this.sortOn = sortOn;
        this.reset();
    };
    JobScansComponent.prototype.onDelete = function (jobScan) {
        var index = this.jobScans.indexOf(jobScan);
        if (index >= 0) {
            this.jobScans.splice(index, 1);
            this.totalCount--;
        }
    };
    JobScansComponent.prototype.workValuesChanged = function (workValues) {
        this.filter.workValues = workValues;
        this.jobScansFilterService.filter$.next(this.filter);
    };
    JobScansComponent.prototype.teamRolesChanged = function (teamRoles) {
        this.filter.teamRoles = teamRoles;
        this.jobScansFilterService.filter$.next(this.filter);
    };
    JobScansComponent.prototype.domainsChanged = function (domains) {
        this.filter.domains = domains;
        this.jobScansFilterService.filter$.next(this.filter);
    };
    JobScansComponent.prototype.clearSearch = function () {
        this.filter.search = '';
        this.searchChanged('');
    };
    JobScansComponent.prototype.searchChanged = function (search) {
        this.jobScansFilterService.filter$.next(this.filter);
    };
    JobScansComponent.prototype.reset = function () {
        this.batchActionService.deSelectAll();
        this.page = 1;
        this.jobScans.splice(0);
        this.totalCount = 0;
        this.fetch$.next(true);
    };
    JobScansComponent.prototype.showBatchDeleteConfirmationModal = function (jobScanIds) {
        var _this = this;
        var count = jobScanIds.length;
        var header = this.translate.instant('jobscans.delete_multiple_modal_header', { count: count });
        var message = this.translate.instant('jobscans.delete_multiple_modal_content', {
            count: count,
            accountName: this.userSettingsService.currentAccount$.getValue().name
        });
        var props = new DeleteModalProps(header, message);
        var initialState = { props: props };
        this.modalService.show(DeleteModalComponent, { initialState: initialState });
        var deleteSub = props.confirm$.subscribe(function () { return _this.deleteJobScans(jobScanIds); });
        this.subscriptions.push(deleteSub);
    };
    JobScansComponent.prototype.deleteJobScans = function (jobScanIds) {
        var _this = this;
        this.identifyingClient.deleteJobScans(jobScanIds.join(','))
            .subscribe(function () {
            _this.batchActionService.deSelectAll();
            _this.batchActionService.actionBarVisible$.next(false);
            jobScanIds.forEach(function (id) {
                var jobScan = _this.jobScans.filter(function (t) { return t.id === id; })[0];
                _this.onDelete(jobScan);
            });
        });
    };
    JobScansComponent.prototype.mapExpectations = function (jobScan, allExpectations) {
        if (!jobScan.expectations) {
            return [];
        }
        var lang = this.translate.currentLang;
        return jobScan.expectations.map(function (exp) {
            var translatedExpectation = allExpectations.filter(function (c) { return c.id === exp.expectationId; })[0];
            exp.expectationTypeId = translatedExpectation.expectationTypeId;
            exp.name = translatedExpectation.name[lang];
            exp.iconUrl = translatedExpectation.iconUrl;
            return exp;
        });
    };
    JobScansComponent.prototype.mapDomains = function (jobScan, allDomains) {
        if (!jobScan.domainIds) {
            return [];
        }
        return jobScan.domainIds.map(function (domainId) { return allDomains.filter(function (dom) { return dom.id === domainId; })[0]; });
    };
    return JobScansComponent;
}());
export { JobScansComponent };
